import { Injectable } from '@angular/core';
import { CommonAccessTokenService, NetworkHelper } from '@wm-libs/core';
import { Observable, take } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Statistics, StatisticsPeriodType } from '../interfaces/statistics.interface';

@Injectable({
  providedIn: 'root',
})
export class StatisticsService {
  readonly apiUrl = `${environment.poolApi}/accounts/statistics`;
  readonly apiAccessTokenUrl = `${environment.poolApi}/access-token/statistics`;

  constructor(private networkHelper: NetworkHelper, private accessTokenService: CommonAccessTokenService) {}

  getStatistics(period: StatisticsPeriodType): Observable<Statistics> {
    const finalApiUrl = this.accessTokenService.isAccessTokenPage() ? this.apiAccessTokenUrl : this.apiUrl;

    return this.networkHelper.get<Statistics>(finalApiUrl, { period }).pipe(take(1));
  }
}
